import React from 'react';
import PropTypes from 'prop-types';
import { Card, Statistic, Radio, Divider } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import InvertorsPower from '../analytics/invertorspower';

/**
 * Dashboard main chart (range controls + summary + inverter power chart)
 */
const SiteChart = ({
  range,
  dateLabel,
  dateValue,
  onPrev,
  onNext,
  onRangeChange,
  summaryLabel,
  roundedGeneration,
  earningsValue,
  fullLoadHours,
}) => {
  return (
    <div className="chartWrapper">
      <div className="controls">
        <Radio.Group
          value={range}
          onChange={(e) => onRangeChange && onRangeChange(e.target.value)}
        >
          <Radio.Button value="d">Day</Radio.Button>
          <Radio.Button value="w">Week</Radio.Button>
          <Radio.Button value="m">Month</Radio.Button>
          <Radio.Button value="y">Year</Radio.Button>
        </Radio.Group>
        <div className="dateNavigator">
          <LeftOutlined
            onClick={onPrev}
            className="navigatorIcon"
          />
          <span className="navigatorDate">
            {dateLabel}
          </span>
          <RightOutlined
            onClick={onNext}
            className="navigatorIcon"
          />
        </div>
      </div>
      <div className="chart">
        <div className="summaryBoxes">
          <Card className="summaryBox">
            <Statistic
              title={`${summaryLabel} Generation`}
              value={roundedGeneration}
              suffix="kWh"
              prefix={null}
            />
          </Card>
          <Divider type="vertical" />
          <Card className="summaryBox">
            <Statistic
              title={`${summaryLabel} Earnings`}
              value={earningsValue}
              precision={2}
              suffix="rmb"
              prefix="¥"
            />
          </Card>
          <Divider type="vertical" />
          <Card className="summaryBox">
            <Statistic
              title="Full Load Hours"
              value={fullLoadHours || 0}
              suffix="hours"
            />
          </Card>
        </div>
        <InvertorsPower date={dateValue} range={range} />
      </div>
    </div>
  );
};

SiteChart.propTypes = {
  range: PropTypes.string.isRequired,
  dateLabel: PropTypes.string.isRequired,
  dateValue: PropTypes.object,
  onPrev: PropTypes.func,
  onNext: PropTypes.func,
  onRangeChange: PropTypes.func,
  summaryLabel: PropTypes.string.isRequired,
  roundedGeneration: PropTypes.number.isRequired,
  earningsValue: PropTypes.number.isRequired,
  fullLoadHours: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default SiteChart;
